module.exports = __webpack_public_path__ + "static/img/doctor.f0b4e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctor.png
// module id = zoJu
// module chunks = 7